/**
 * Microsoft Authentication Library (MSAL) configuration
 */

import { Configuration, PublicClientApplication } from '@azure/msal-browser'

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case 0: // Error
            console.error(message)
            break
          case 1: // Warning
            console.warn(message)
            break
          case 2: // Info
            console.info(message)
            break
          case 3: // Verbose
            console.debug(message)
            break
        }
      },
    },
  },
}

// Login request configuration
export const loginRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'openid', 'profile', 'email'],
}

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig)

// Store redirect result for later use
let redirectResult: Awaited<ReturnType<typeof msalInstance.handleRedirectPromise>> = null

// Initialize MSAL and handle any redirect response
export const initializeMsal = async () => {
  await msalInstance.initialize()
  redirectResult = await msalInstance.handleRedirectPromise()
}

// Get the result from redirect (if any)
export const getRedirectResult = () => redirectResult

// Clear the redirect result after using it (prevents stale data)
export const clearRedirectResult = () => {
  redirectResult = null
}
